/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { listMvsAdminMvsGet } from '../fn/admin/list-mvs-admin-mvs-get';
import { ListMvsAdminMvsGet$Params } from '../fn/admin/list-mvs-admin-mvs-get';
import { BackendMvListResponseDto } from '../models/backend-mv-list-response-dto';
import { BackendMvRefreshResponseDto } from '../models/backend-mv-refresh-response-dto';
import { BackendMvRefreshResultDto } from '../models/backend-mv-refresh-result-dto';
import { refreshAllEndpointAdminRefreshPost } from '../fn/admin/refresh-all-endpoint-admin-refresh-post';
import { RefreshAllEndpointAdminRefreshPost$Params } from '../fn/admin/refresh-all-endpoint-admin-refresh-post';
import { refreshOneEndpointAdminRefreshNamePost } from '../fn/admin/refresh-one-endpoint-admin-refresh-name-post';
import { RefreshOneEndpointAdminRefreshNamePost$Params } from '../fn/admin/refresh-one-endpoint-admin-refresh-name-post';

@Injectable({ providedIn: 'root' })
export class BackendApiAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listMvsAdminMvsGet()` */
  static readonly ListMvsAdminMvsGetPath = '/admin/mvs';

  /**
   * Список зарегистрированных materialized views.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMvsAdminMvsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMvsAdminMvsGet$Response(
    params?: ListMvsAdminMvsGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMvListResponseDto>> {
    return listMvsAdminMvsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Список зарегистрированных materialized views.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMvsAdminMvsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMvsAdminMvsGet(params?: ListMvsAdminMvsGet$Params, context?: HttpContext): Observable<BackendMvListResponseDto> {
    return this.listMvsAdminMvsGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMvListResponseDto>): BackendMvListResponseDto => r.body),
    );
  }

  /** Path part for operation `refreshAllEndpointAdminRefreshPost()` */
  static readonly RefreshAllEndpointAdminRefreshPostPath = '/admin/refresh';

  /**
   * Ручной REFRESH всех зарегистрированных MV.
   *
   * Освежает все MV из реестра. Ошибка одного не валит остальных. Только для пользователей с is_admin=True.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshAllEndpointAdminRefreshPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshAllEndpointAdminRefreshPost$Response(
    params?: RefreshAllEndpointAdminRefreshPost$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMvRefreshResponseDto>> {
    return refreshAllEndpointAdminRefreshPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Ручной REFRESH всех зарегистрированных MV.
   *
   * Освежает все MV из реестра. Ошибка одного не валит остальных. Только для пользователей с is_admin=True.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refreshAllEndpointAdminRefreshPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshAllEndpointAdminRefreshPost(
    params?: RefreshAllEndpointAdminRefreshPost$Params,
    context?: HttpContext,
  ): Observable<BackendMvRefreshResponseDto> {
    return this.refreshAllEndpointAdminRefreshPost$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMvRefreshResponseDto>): BackendMvRefreshResponseDto => r.body),
    );
  }

  /** Path part for operation `refreshOneEndpointAdminRefreshNamePost()` */
  static readonly RefreshOneEndpointAdminRefreshNamePostPath = '/admin/refresh/{name}';

  /**
   * Ручной REFRESH одного MV.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshOneEndpointAdminRefreshNamePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshOneEndpointAdminRefreshNamePost$Response(
    params: RefreshOneEndpointAdminRefreshNamePost$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMvRefreshResultDto>> {
    return refreshOneEndpointAdminRefreshNamePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Ручной REFRESH одного MV.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refreshOneEndpointAdminRefreshNamePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshOneEndpointAdminRefreshNamePost(
    params: RefreshOneEndpointAdminRefreshNamePost$Params,
    context?: HttpContext,
  ): Observable<BackendMvRefreshResultDto> {
    return this.refreshOneEndpointAdminRefreshNamePost$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMvRefreshResultDto>): BackendMvRefreshResultDto => r.body),
    );
  }
}
